import React, { useState } from 'react';
import css from './ListenerCopyPosts.module.css';

/**
 * Listener "Copy post" (Sam, Oct 21 2026, TEST): two ready posts with the
 * listener's own link inserted. Copies to their clipboard only; the site sends nothing.
 */
export const listenerPosts = link => [
  {
    id: 'A',
    text: `I'm a listener here. If you ever need someone to just hear you out, with no judging and no fixing, I'm here. Your first 15 minutes are free, and you can text, call or video, whatever feels easiest. 💗 ${link}`,
  },
  {
    id: 'B',
    text: `Need to get something off your chest? Talk to me here. Your first 15 minutes are free. 💗 ${link}`,
  },
];

const ListenerCopyPosts = ({ link, className, tone }) => {
  const [copied, setCopied] = useState(null);
  const copy = (id, text) => {
    const done = () => {
      setCopied(id);
      window.setTimeout(() => setCopied(null), 2500);
    };
    try {
      navigator.clipboard.writeText(text).then(done, done);
    } catch (e) {
      done();
    }
  };
  return (
    <div className={[css.root, className].filter(Boolean).join(' ')} data-listener-copy-posts="true">
      <strong className={css.title} style={tone === "dark" ? { color: "#fff" } : undefined}>Ready-to-share posts</strong>
      {listenerPosts(link).map(p => (
        <div key={p.id} className={css.post}>
          <p className={css.text}>{p.text}</p>
          <button
            type="button"
            className={css.btn}
            onClick={() => copy(p.id, p.text)}
            data-copy-post={p.id}
          >
            {copied === p.id ? 'Copied!' : 'Copy post'}
          </button>
        </div>
      ))}
    </div>
  );
};

export default ListenerCopyPosts;
